export class Tarjeta {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                export: false,
                table: false,
            },
            emisor: {
                value: '',
                export: false,
                table: true,
                header: 'EMISOR:',
                required: 'Emisor es requerido',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
            },
            numero_tarjeta: {
                value: '',
                export: false,
                table: true,
                header: 'NÚMERO DE TARJETA:',
                required: 'Número de tarjeta es requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
            },
            fecha_expedicion: {
                value: null,
                export: false,
                table: true,
                header: 'FECHA DE EXPEDICIÓN:',
                required: 'Fecha de expedición es requerida',
            },
            cupo_credito: {
                value: null,
                export: false,
                table: true,
                sort: false,
                filter: false,
                header: 'CUPO DE CRÉDITO\nOTORGADO USD USD:',
                required: 'Cupo de crédito es requerido',
            },
        }
    }

    optionLabel = 'nombre';
}
